import React from 'react';

import Modal from '~components/Modal';
import { Form as WizardForm } from '~components/wizard-form';

import singleSteps from '~appointments/forms/appointments/bulkUpdatePackages';
import repeatSteps from '~appointments/forms/repeats/bulkUpdatePackages';

interface ComponentProps {
  isOpen: boolean;
  setIsOpen: (toggle: boolean) => void;
  type: 'singles' | 'repeats';
}

const BulkUpdatePackageWizard: React.FC<ComponentProps> = ({ isOpen, setIsOpen, type }) => {
  let steps;
  let headerText;
  const values: { is_repeat?: boolean } = {};
  switch (type) {
    case 'repeats':
      steps = repeatSteps;
      headerText = 'Repeat Appointments';
      values.is_repeat = true;
      break;
    case 'singles':
    default:
      steps = singleSteps;
      headerText = 'Single Appointments';
      break;
  }

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      header={`Bulk Update - Packages (${headerText})`}
      headerClassName="header"
      contentClassName="wizard-modal"
      includeFooter={false}
      unmountOnClose
    >
      <WizardForm steps={steps} initialValues={values} onComplete={() => setIsOpen(false)} submitCaption="Close" />
    </Modal>
  );
};

export default BulkUpdatePackageWizard;
